module.exports = __webpack_public_path__ + "img/40_38_063_380.e812874c.jpg";